import modalTemplate from './view.html';
import { EditSelectedModalController } from './controller';

import { EDIT_SELECTED_MODAL_CONTROLLER } from '../../const';

class EditSelectedModal {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.modalInstance = null;
    }

    $onInit = () => {
        this.$uibModal;
    };

    open = (selectedData = null) => {
        this.modalInstance = this.$uibModal.open({
            template: modalTemplate,
            bindToController: true,
            controller: EDIT_SELECTED_MODAL_CONTROLLER,
            controllerAs: '$',
            size: 'md',
            resolve: {
                selectedData: selectedData,
            },
            backdrop: 'static',
            keyboard: false,
        });

        return this.modalInstance.result;
    };
}

export {
    EditSelectedModal,
    EditSelectedModalController,
};
